import { c as _c } from "react/compiler-runtime";
import { ResponsiveImage } from '@/components/Atoms/ResponsiveImage/ResponsiveImage';
import { toasterEmbededParams } from '@/hooks/useToaster';
import type { IImage, IToasterData } from '@/interfaces';
import type { ResponsiveImageHints } from '@/services/ResponsiveImageHints';
import classNames from '@/utils/classNames';
import dynamic from 'next/dynamic';
import type { ImgHTMLAttributes } from 'react';
import { useState } from 'react';
import styles from './ImageWithToaster.module.css';
export const ImageWithToaster = t0 => {
  const $ = _c(18);
  let colorScheme;
  let rest;
  let src;
  let toasterData;
  if ($[0] !== t0) {
    ({
      toasterData,
      colorScheme,
      src,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = colorScheme;
    $[2] = rest;
    $[3] = src;
    $[4] = toasterData;
  } else {
    colorScheme = $[1];
    rest = $[2];
    src = $[3];
    toasterData = $[4];
  }
  const [iframeLoaded, setIframeLoaded] = useState(false);
  let t1;
  if ($[5] !== colorScheme || $[6] !== iframeLoaded || $[7] !== toasterData) {
    t1 = toasterData?.id && <CsrToasterEmbed key={colorScheme} id={toasterData.id} {...toasterEmbededParams(colorScheme)} onReady={() => {
      setIframeLoaded(true);
    }} className={classNames(styles.toasterFrame, {
      [styles.hidden]: !iframeLoaded
    })} data-toaster-iframe={true} />;
    $[5] = colorScheme;
    $[6] = iframeLoaded;
    $[7] = toasterData;
    $[8] = t1;
  } else {
    t1 = $[8];
  }
  let t2;
  if ($[9] !== iframeLoaded) {
    t2 = classNames({
      [styles.image]: true,
      [styles.hidden]: iframeLoaded
    });
    $[9] = iframeLoaded;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  let t3;
  if ($[11] !== rest || $[12] !== src || $[13] !== t2) {
    t3 = <ResponsiveImage src={src} className={t2} {...rest} />;
    $[11] = rest;
    $[12] = src;
    $[13] = t2;
    $[14] = t3;
  } else {
    t3 = $[14];
  }
  let t4;
  if ($[15] !== t1 || $[16] !== t3) {
    t4 = <>{t1}{t3}</>;
    $[15] = t1;
    $[16] = t3;
    $[17] = t4;
  } else {
    t4 = $[17];
  }
  return t4;
};
interface IProps extends Omit<ImgHTMLAttributes<HTMLImageElement>, 'src'> {
  src: IImage;
  sizeHints: ResponsiveImageHints;
  toasterData?: IToasterData;
  /** Override the default (system) color scheme */
  colorScheme?: 'light' | 'dark';
}

// Dynamic imports always get converted to "require" during build. However, Toaster is not compatible with require.
// Therefore, we import our own wrapper dynamically, which itself can import Toaster as an ESM
const CsrToasterEmbed = dynamic(() => import('./csrToaster'), {
  ssr: false
});